import React from "react";
import { Lock } from "lucide-react";

type Props = { title: string; unlockTier?: string | null; enabled?: boolean };

export const FeatureLocked: React.FC<Props> = ({ title, unlockTier, enabled = true }) => (
  <div className="space-y-6 animate-fade-in" data-testid="feature-locked">
    <div>
      <h1 className="text-3xl font-serif font-medium">{title}</h1>
    </div>
    <div className="card-obsidian p-12 text-center max-w-lg mx-auto">
      <div className="w-16 h-16 mx-auto rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center mb-5">
        <Lock className="w-7 h-7 text-gold" />
      </div>
      {!enabled ? (
        <>
          <h2 className="text-xl font-serif font-medium mb-2">No disponible por el momento</h2>
          <p className="text-sm text-slate-500">Esta sección no está habilitada actualmente. Vuelve a intentarlo más tarde.</p>
        </>
      ) : (
        <>
          <h2 className="text-xl font-serif font-medium mb-2">No disponible en tu nivel</h2>
          <p className="text-sm text-slate-500">
            Esta funcionalidad está disponible a partir del nivel{" "}
            <span className="text-gold-ink font-semibold">{unlockTier || "superior"}</span>. Sigue acumulando puntos para desbloquearla.
          </p>
        </>
      )}
    </div>
  </div>
);
